<template>
  <div class="container footer">
    <div class="row w-100">
      <div class="col-12 col-lg-4 mb-3">
        <img class="footer-logo" src="/assets/images/logo-footer.png" />
        <div class="social-links">          
          <a href="https://www.instagram.com/valhallaverse/" target="_blank"><fa :icon="['fab', 'instagram']" /></a>
          <a href="https://t.me/ValhallaVerseOfficial" target="_blank"><fa :icon="['fab', 'telegram']" /></a>
          <a href="https://twitter.com/ValhallaVerse" target="_blank"><fa :icon="['fab', 'twitter']" /></a>
          <a href="https://medium.com/@valhallaverse" target="_blank"><fa :icon="['fab', 'medium']" /></a>
          <!-- <a href="#" target="_blank"><fa :icon="['fab', 'youtube']" /></a> -->
        </div>
      </div>
      <div class="col-12 col-lg-7 offset-lg-1">
        <!-- Mobile Menu-->
        <div class="row no-gutters" v-if="$device.mobile">
          <div class="col-6 col-lg-4">
            <ul class="list-unstyled text-small">
              <router-link class="nav-link" :to="{ path: '/', hash: '#home' }">
                Home
              </router-link>
              <router-link class="nav-link" :to="{ path: '/', hash: '#details' }">
                Game
              </router-link>
              <router-link class="nav-link" :to="{ path: '/', hash: '#nfts' }">
                NFTs
              </router-link>
            </ul>
          </div>
          <div class="col-6 col-lg-5">
            <ul class="list-unstyled text-small">
              <router-link class="nav-link" :to="{ path: '/', hash: '#skillcards' }">
                Skill cards
              </router-link>
              <li><a class="nav-link" href="#">Marketplace</a></li>
              <li><a class="nav-link" href="#">Whitepaper</a></li>
            </ul>
          </div>
          <div class="col-3"></div>
        </div>
        <!-- Desktop Menu-->
        <div class="row no-gutters" v-else>
          <div class="col-6 col-lg-4">
            <ul class="list-unstyled text-small">
              <router-link class="nav-link" to="/">Home</router-link>
              <router-link class="nav-link" :to="{ path: '/', hash: '#details' }">
                Game
              </router-link>
              <router-link class="nav-link" :to="{ path: '/warrior', hash: '#nfts' }">
                NFTs
              </router-link>
            </ul>
          </div>
          <div class="col-6 col-lg-5">
            <ul class="list-unstyled text-small">
              <router-link
                class="nav-link"
                :to="{ path: '/warrior', hash: '#skillcards' }"
              >
                Skill cards
              </router-link>
              <li><a class="nav-link" href="#">Marketplace</a></li>
              <li><a class="nav-link" href="#">Whitepaper</a></li>
            </ul>
          </div>
          <div class="col-3"></div>
        </div>
      </div>
    </div>
    <hr class="bg-white" />
    <div class="pb-3 d-lg-flex">
      <div>Copyright © 2022 - ValhallaVerse</div>
      <div class="ml-lg-auto">
        <span>Terms of Service</span>
        <span class="ml-4">Privacy Policy</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Foot",
};
</script>

<style lang="scss" scoped>
.footer {
  position: relative;
  font-family: Poppins;
  color: white;
  z-index: 5;
  .footer-logo {
    max-width: 107px;
  }
  .social-links {
    margin-right: 1rem;
    margin-top: 2rem;
    a {
      &:hover {
        background: #ffeec2;
      }
      opacity: 1;
      margin-left: 1rem;
      font-size: 1rem;
      width: 1.75rem;
      height: 1.75rem;
      background: white;
      color: black;
      display: inline-block;
      text-align: center;
      line-height: 1.75;
      border-radius: 0.5rem;
      cursor: pointer;
    }
  }
}
</style>
